import { PaymentMethodsServerKeys, CompanyCodes } from "@/interfaces/rapydTypes";

export default function PaymentChannelIcon({
	channelName,
	companyCode,
}: {
	channelName: string;
	companyCode?: string;
}) {
	switch (channelName) {
		case PaymentMethodsServerKeys.CARD: {
			if (companyCode === CompanyCodes.DCS) {
				return <DESIcon />;
			}
			return <CardIcon />;
		}
		case PaymentMethodsServerKeys.BANK:
			return <BankIcon />;
		case PaymentMethodsServerKeys.E_WALLET: {
			if (companyCode === CompanyCodes.VCPAY) {
				return <VcPayIcon />;
			}
			return <WalletIcon />;
		}

		case PaymentMethodsServerKeys.WIRE_TRANSFER:
			return <WireTransferIcon />;
		case PaymentMethodsServerKeys.SG_WIRE_TRANSFER:
			return <WireTransferIcon />;
		case PaymentMethodsServerKeys.HK_WIRE_TRANSFER:
			return <HKWireTransferIcon />;
		default:
			return <DESIcon />;
	}
}

function CardIcon() {
	return (
		<svg width="37" height="37" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g id="Frame 222">
				<g id="&#231;&#188;&#150;&#231;&#187;&#132; 5">
					<rect
						id="&#231;&#159;&#169;&#229;&#189;&#162;"
						x="2.5"
						y="1.5"
						width="17.7586"
						height="30.3793"
						rx="1.5"
						fill="none"
						stroke="currentColor"
					/>
					<rect
						id="&#231;&#159;&#169;&#229;&#189;&#162;_2"
						x="4.59473"
						y="3.66382"
						width="4.18966"
						height="4.32759"
						rx="0.25"
						stroke="currentColor"
						strokeWidth="0.5"
					/>
					<path
						id="&#231;&#159;&#169;&#229;&#189;&#162;_3"
						d="M21.7452 22.0172L34.9759 22.0172L24.4615 35.5L11.2308 35.5L21.7452 22.0172Z"
						fill="none"
						stroke="currentColor"
					/>
					<path id="&#232;&#183;&#175;&#229;&#190;&#132; 6" d="M19.759 25.093H32.834" stroke="currentColor" />
				</g>
			</g>
		</svg>
	);
}

function BankIcon() {
	return (
		<svg width="37" height="37" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g id="Frame 225">
				<g id="&#231;&#188;&#150;&#231;&#187;&#132; 2">
					<g id="&#231;&#188;&#150;&#231;&#187;&#132;">
						<path
							id="&#231;&#159;&#169;&#229;&#189;&#162;&#229;&#164;&#135;&#228;&#187;&#189; 2"
							d="M10.1086 7.1745L10.1086 28.9009H7.09921L7.09921 7.1745L10.1086 7.1745Z"
							fill="currentColor"
							stroke="none"
							strokeWidth="0.5"
						/>
						<path
							id="&#231;&#159;&#169;&#229;&#189;&#162;&#229;&#164;&#135;&#228;&#187;&#189; 3"
							d="M15.9575 7.1745L15.9575 28.9009H12.9481L12.9481 7.1745L15.9575 7.1745Z"
							fill="currentColor"
							stroke="none"
							strokeWidth="0.5"
						/>
						<path
							id="&#231;&#159;&#169;&#229;&#189;&#162;&#229;&#164;&#135;&#228;&#187;&#189; 4"
							d="M21.8066 7.1745L21.8066 28.9009H18.7972L18.7972 7.1745L21.8066 7.1745Z"
							fill="currentColor"
							stroke="none"
							strokeWidth="0.5"
						/>
						<path
							id="&#231;&#159;&#169;&#229;&#189;&#162;&#229;&#164;&#135;&#228;&#187;&#189; 5"
							d="M27.6558 7.1745L27.6558 28.9009H24.6463L24.6463 7.1745L27.6558 7.1745Z"
							fill="currentColor"
							stroke="none"
							strokeWidth="0.5"
						/>
					</g>
					<g id="&#232;&#183;&#175;&#229;&#190;&#132; 6&#229;&#164;&#135;&#228;&#187;&#189;">
						<path fillRule="evenodd" clipRule="evenodd" d="M8.01899 7.0545V21.394V7.0545Z" fill="currentColor" />
						<path d="M8.01899 7.0545V21.394" stroke="none" strokeWidth="0.25" />
					</g>
					<g id="&#232;&#183;&#175;&#229;&#190;&#132; 6&#229;&#164;&#135;&#228;&#187;&#189; 3">
						<path fillRule="evenodd" clipRule="evenodd" d="M13.8679 7.0545V21.394V7.0545Z" fill="currentColor" />
						<path d="M13.8679 7.0545V21.394" stroke="none" strokeWidth="0.25" />
					</g>
					<g id="&#232;&#183;&#175;&#229;&#190;&#132; 6&#229;&#164;&#135;&#228;&#187;&#189; 2">
						<path fillRule="evenodd" clipRule="evenodd" d="M8.95478 7.0545V21.394V7.0545Z" fill="currentColor" />
						<path d="M8.95478 7.0545V21.394" stroke="none" strokeWidth="0.25" />
					</g>
					<g id="&#232;&#183;&#175;&#229;&#190;&#132; 6&#229;&#164;&#135;&#228;&#187;&#189; 4">
						<path fillRule="evenodd" clipRule="evenodd" d="M14.8039 7.0545V21.394V7.0545Z" fill="currentColor" />
						<path d="M14.8039 7.0545V21.394" stroke="none" strokeWidth="0.25" />
					</g>
					<g id="&#232;&#183;&#175;&#229;&#190;&#132; 6&#229;&#164;&#135;&#228;&#187;&#189; 6">
						<path fillRule="evenodd" clipRule="evenodd" d="M19.9509 7.0545V21.394V7.0545Z" fill="currentColor" />
						<path d="M19.9509 7.0545V21.394" stroke="none" strokeWidth="0.25" />
					</g>
					<g id="&#232;&#183;&#175;&#229;&#190;&#132; 6&#229;&#164;&#135;&#228;&#187;&#189; 5">
						<path fillRule="evenodd" clipRule="evenodd" d="M20.7697 7.0545V21.394V7.0545Z" fill="currentColor" />
						<path d="M20.7697 7.0545V21.394" stroke="none" strokeWidth="0.25" />
					</g>
					<g id="&#232;&#183;&#175;&#229;&#190;&#132; 6&#229;&#164;&#135;&#228;&#187;&#189; 8">
						<path fillRule="evenodd" clipRule="evenodd" d="M25.8 7.0545V23.8868V7.0545Z" fill="currentColor" />
						<path d="M25.8 7.0545V23.8868" stroke="none" strokeWidth="0.25" />
					</g>
					<g id="&#232;&#183;&#175;&#229;&#190;&#132; 6&#229;&#164;&#135;&#228;&#187;&#189; 7">
						<path fillRule="evenodd" clipRule="evenodd" d="M26.6188 7.0545V26.2264V7.0545Z" fill="currentColor" />
						<path d="M26.6188 7.0545V26.2264" stroke="none" strokeWidth="0.25" />
					</g>
					<rect
						id="&#231;&#159;&#169;&#229;&#189;&#162;"
						x="5.00952"
						y="4.5"
						width="24.7358"
						height="2.95936"
						fill="currentColor"
						stroke="none"
					/>
					<g id="&#229;&#189;&#162;&#231;&#138;&#182;&#231;&#187;&#147;&#229;&#144;&#136;">
						<mask id="path-22-inside-1_11101_3285" fill="currentColor">
							<path
								fillRule="evenodd"
								clipRule="evenodd"
								d="M27.9056 25.0566C27.9056 25.2605 27.8964 25.4626 27.8782 25.6624C28.0798 25.6486 28.284 25.6415 28.4906 25.6415C32.0439 25.6415 34.9245 27.7365 34.9245 30.3208C34.9245 32.905 32.0439 35 28.4906 35C25.7885 35 23.4755 33.7886 22.5223 32.0719C21.4793 32.4509 20.3339 32.6604 19.1321 32.6604C17.115 32.6604 15.2569 32.0705 13.775 31.0789C12.5062 32.7423 10.4011 33.8302 8.01887 33.8302C4.14245 33.8302 1 30.9496 1 27.3962C1 23.8428 4.14245 20.9622 8.01887 20.9622C9.18942 20.9622 10.293 21.2249 11.2634 21.6894C12.6964 19.1791 15.6816 17.4528 19.1321 17.4528C23.9776 17.4528 27.9056 20.8571 27.9056 25.0566Z"
							/>
						</mask>
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							d="M27.9056 25.0566C27.9056 25.2605 27.8964 25.4626 27.8782 25.6624C28.0798 25.6486 28.284 25.6415 28.4906 25.6415C32.0439 25.6415 34.9245 27.7365 34.9245 30.3208C34.9245 32.905 32.0439 35 28.4906 35C25.7885 35 23.4755 33.7886 22.5223 32.0719C21.4793 32.4509 20.3339 32.6604 19.1321 32.6604C17.115 32.6604 15.2569 32.0705 13.775 31.0789C12.5062 32.7423 10.4011 33.8302 8.01887 33.8302C4.14245 33.8302 1 30.9496 1 27.3962C1 23.8428 4.14245 20.9622 8.01887 20.9622C9.18942 20.9622 10.293 21.2249 11.2634 21.6894C12.6964 19.1791 15.6816 17.4528 19.1321 17.4528C23.9776 17.4528 27.9056 20.8571 27.9056 25.0566Z"
							fill="currentColor"
						/>
						<path
							d="M27.8782 25.6624L26.8823 25.5719L26.776 26.7405L27.9467 26.6601L27.8782 25.6624ZM22.5223 32.0719L23.3966 31.5865L22.9825 30.8407L22.1807 31.132L22.5223 32.0719ZM13.775 31.0789L14.3311 30.2478L13.55 29.7251L12.9799 30.4724L13.775 31.0789ZM11.2634 21.6894L10.8316 22.5914L11.6707 22.9931L12.1319 22.1852L11.2634 21.6894ZM28.8741 25.753C28.895 25.5231 28.9056 25.2908 28.9056 25.0566H26.9056C26.9056 25.2302 26.8978 25.402 26.8823 25.5719L28.8741 25.753ZM28.4906 24.6415C28.2612 24.6415 28.0341 24.6494 27.8097 24.6648L27.9467 26.6601C28.1255 26.6478 28.3069 26.6415 28.4906 26.6415V24.6415ZM35.9245 30.3208C35.9245 28.6299 34.9802 27.1865 33.6282 26.2033C32.2753 25.2194 30.4556 24.6415 28.4906 24.6415V26.6415C30.0788 26.6415 31.4762 27.1111 32.4519 27.8208C33.4286 28.5311 33.9245 29.4274 33.9245 30.3208H35.9245ZM28.4906 36C30.4556 36 32.2753 35.4222 33.6282 34.4382C34.9802 33.455 35.9245 32.0117 35.9245 30.3208H33.9245C33.9245 31.2141 33.4286 32.1104 32.4519 32.8207C31.4762 33.5304 30.0788 34 28.4906 34V36ZM21.648 32.5573C22.826 34.6788 25.5372 36 28.4906 36V34C26.0398 34 24.1251 32.8985 23.3966 31.5865L21.648 32.5573ZM19.1321 33.6604C20.4502 33.6604 21.7112 33.4307 22.8638 33.0118L22.1807 31.132C21.2474 31.4712 20.2176 31.6604 19.1321 31.6604V33.6604ZM13.2189 31.91C14.8683 33.0136 16.9205 33.6604 19.1321 33.6604V31.6604C17.3095 31.6604 15.6456 31.1273 14.3311 30.2478L13.2189 31.91ZM12.9799 30.4724C11.905 31.8816 10.0971 32.8302 8.01887 32.8302V34.8302C10.7051 34.8302 13.1074 33.6029 14.5701 31.6854L12.9799 30.4724ZM8.01887 32.8302C4.61105 32.8302 2 30.3172 2 27.3962H0C0 31.582 3.67386 34.8302 8.01887 34.8302V32.8302ZM2 27.3962C2 24.4752 4.61105 21.9622 8.01887 21.9622V19.9622C3.67386 19.9622 0 23.2104 0 27.3962H2ZM8.01887 21.9622C9.03916 21.9622 9.99531 22.1911 10.8316 22.5914L11.6952 20.7875C10.5908 20.2588 9.33968 19.9622 8.01887 19.9622V21.9622ZM19.1321 16.4528C15.3599 16.4528 12.0236 18.3405 10.3949 21.1937L12.1319 22.1852C13.3691 20.0177 16.0034 18.4528 19.1321 18.4528V16.4528ZM28.9056 25.0566C28.9056 20.1753 24.3907 16.4528 19.1321 16.4528V18.4528C23.5644 18.4528 26.9056 21.539 26.9056 25.0566H28.9056Z"
							fill="none"
							mask="url(#path-22-inside-1_11101_3285)"
						/>
					</g>
				</g>
			</g>
		</svg>
	);
}

function WalletIcon() {
	return (
		<svg width="37" height="37" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g id="Frame 226">
				<g id="Group 2390">
					<path
						id="Vector"
						d="M4.38281 13.8983H24.859C25.5373 13.8983 26.1879 14.1832 26.6676 14.6905C27.1472 15.1977 27.4167 15.8857 27.4167 16.6031V30.911C27.4167 31.2662 27.3505 31.6179 27.222 31.9461C27.0935 32.2742 26.9051 32.5724 26.6676 32.8236C26.4301 33.0747 26.1481 33.274 25.8378 33.4099C25.5275 33.5458 25.1949 33.6158 24.859 33.6158H6.92599C6.25016 33.6117 5.60333 33.325 5.1268 32.8182C4.65028 32.3113 4.3828 31.6257 4.38281 30.911V13.8983Z"
						fill="none"
						stroke="currentColor"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						id="Vector_2"
						d="M6.35922 8.45789H22.0906C22.6147 8.45789 23.1174 8.67809 23.4881 9.07006C23.8587 9.46203 24.067 9.99365 24.067 10.548V13.8983H4.38281V10.548C4.38281 9.99365 4.59104 9.46203 4.96169 9.07006C5.33234 8.67809 5.83505 8.45789 6.35922 8.45789Z"
						fill="none"
						stroke="currentColor"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						id="Vector_3"
						d="M4.38281 11.178H17.4693"
						stroke="currentColor"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						id="Vector_4"
						d="M19.4819 11.178H21.0369"
						stroke="currentColor"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						id="Vector_5"
						d="M20.136 20.4374H27.4022V27.0842H20.136C19.9146 27.0842 19.6954 27.0381 19.4909 26.9485C19.2863 26.8589 19.1005 26.7276 18.944 26.5621C18.7874 26.3965 18.6632 26.2 18.5785 25.9837C18.4938 25.7674 18.4502 25.5356 18.4502 25.3015V22.2278C18.4493 21.9931 18.4922 21.7604 18.5764 21.5433C18.6607 21.3261 18.7847 21.1287 18.9414 20.9623C19.098 20.7959 19.2842 20.6639 19.4892 20.5739C19.6942 20.4838 19.914 20.4374 20.136 20.4374Z"
						stroke="currentColor"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						id="Vector_6"
						d="M21.7128 24.8866C22.3268 24.8866 22.8245 24.3602 22.8245 23.7109C22.8245 23.0616 22.3268 22.5352 21.7128 22.5352C21.0988 22.5352 20.6011 23.0616 20.6011 23.7109C20.6011 24.3602 21.0988 24.8866 21.7128 24.8866Z"
						fill="currentColor"
					/>
					<path
						id="Vector_7"
						d="M25.8181 6.65977C27.0324 5.81338 28.4547 5.36224 29.909 5.36224C31.3633 5.36224 32.7856 5.81338 33.9999 6.65977"
						stroke="currentColor"
						strokeMiterlimit="10"
						strokeLinecap="round"
					/>
					<path
						id="Vector_8"
						d="M26.6973 8.11979C27.6491 7.47401 28.7562 7.13074 29.8871 7.13074C31.018 7.13074 32.1251 7.47401 33.077 8.11979"
						stroke="currentColor"
						strokeMiterlimit="10"
						strokeLinecap="round"
					/>
					<path
						id="Vector_9"
						d="M27.6057 9.61047C28.3256 9.151 29.1558 8.92151 29.9963 8.94963C30.7116 8.96628 31.4124 9.16671 32.0381 9.53363"
						stroke="currentColor"
						strokeMiterlimit="10"
						strokeLinecap="round"
					/>
					<path
						id="Vector_10"
						d="M29.8073 12.0771C30.2006 12.0771 30.5194 11.7399 30.5194 11.324C30.5194 10.9081 30.2006 10.571 29.8073 10.571C29.414 10.571 29.0952 10.9081 29.0952 11.324C29.0952 11.7399 29.414 12.0771 29.8073 12.0771Z"
						fill="currentColor"
					/>
				</g>
			</g>
		</svg>
	);
}

function WireTransferIcon() {
	return (
		<svg width="37" height="37" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g id="Frame 224">
				<g id="&#231;&#188;&#150;&#231;&#187;&#132; 3">
					<g id="&#232;&#183;&#175;&#229;&#190;&#132; 7">
						<path fillRule="evenodd" clipRule="evenodd" d="M15.8684 10.2609H21.7095H15.8684Z" fill="currentColor" />
						<path d="M15.8684 10.2609H21.7095" stroke="currentColor" strokeDasharray="1 1" />
					</g>
					<g id="&#232;&#183;&#175;&#229;&#190;&#132; 7&#229;&#164;&#135;&#228;&#187;&#189;">
						<path fillRule="evenodd" clipRule="evenodd" d="M15.7622 29.7391H25.4266H15.7622Z" fill="currentColor" />
						<path d="M15.7622 29.7391H25.4266" stroke="currentColor" strokeDasharray="1 1" />
					</g>
					<g id="&#232;&#183;&#175;&#229;&#190;&#132; 7&#229;&#164;&#135;&#228;&#187;&#189; 2">
						<path fillRule="evenodd" clipRule="evenodd" d="M30.7161 27.1827V12.0756V27.1827Z" fill="currentColor" />
						<path d="M30.7161 27.1827V12.0756" stroke="currentColor" strokeDasharray="1 1" />
					</g>
					<rect
						id="&#231;&#159;&#169;&#229;&#189;&#162;"
						x="1.5"
						y="6.5"
						width="12.8063"
						height="27"
						rx="0.5"
						fill="none"
						stroke="currentColor"
					/>
					<rect
						id="&#231;&#159;&#169;&#229;&#189;&#162;&#229;&#164;&#135;&#228;&#187;&#189; 8"
						x="3.37402"
						y="8.56311"
						width="9.05823"
						height="22.6304"
						rx="0.75"
						fill="none"
						stroke="currentColor"
						strokeWidth="0.5"
					/>
					<rect
						id="&#231;&#159;&#169;&#229;&#189;&#162;&#229;&#164;&#135;&#228;&#187;&#189; 6"
						x="22.9529"
						y="6.5"
						width="12.8063"
						height="11.1739"
						rx="0.5"
						fill="none"
						stroke="currentColor"
					/>
					<rect
						id="&#231;&#159;&#169;&#229;&#189;&#162;&#229;&#164;&#135;&#228;&#187;&#189; 9"
						x="24.8269"
						y="8.68469"
						width="9.05823"
						height="6.80435"
						rx="0.75"
						fill="none"
						stroke="currentColor"
						strokeWidth="0.5"
					/>
					<rect
						id="&#231;&#159;&#169;&#229;&#189;&#162;&#229;&#164;&#135;&#228;&#187;&#189; 7"
						x="27.2009"
						y="25.9783"
						width="6.43418"
						height="7.52174"
						rx="0.5"
						fill="none"
						stroke="currentColor"
					/>
					<rect
						id="&#231;&#159;&#169;&#229;&#189;&#162;&#229;&#164;&#135;&#228;&#187;&#189; 10"
						x="28.4189"
						y="27.4293"
						width="3.9981"
						height="4.61957"
						rx="0.875"
						fill="none"
						stroke="currentColor"
						strokeWidth="0.25"
					/>
				</g>
			</g>
		</svg>
	);
}

function HKWireTransferIcon() {
	return (
		<svg width="37" height="37" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect x="2.5" y="3.5" width="13.9235" height="13.9235" rx="0.5" fill="none" stroke="currentColor" />
			<rect
				x="4.5459"
				y="5.5459"
				width="9.83164"
				height="9.83164"
				rx="0.75"
				fill="none"
				stroke="currentColor"
				strokeWidth="0.5"
			/>
			<rect x="23.1633" y="23.0154" width="11.6276" height="11.6276" rx="0.5" fill="none" stroke="currentColor" />
			<rect
				x="25.0842"
				y="24.9363"
				width="7.78572"
				height="7.78572"
				rx="0.875"
				fill="none"
				stroke="currentColor"
				strokeWidth="0.25"
			/>
			<path d="M18 9H32.5V21.5" stroke="currentColor" strokeDasharray="1 1" />
			<path d="M5.5 18.5V31H21.5" stroke="currentColor" strokeDasharray="1 1" />
		</svg>
	);
}

function DESIcon() {
	return (
		<svg width="37" height="37" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect x="3.5" y="1.5" width="17.7586" height="30.3793" rx="1.5" fill="none" stroke="currentColor" />
			<rect
				x="5.59473"
				y="3.66382"
				width="4.18966"
				height="4.32759"
				rx="0.25"
				stroke="currentColor"
				strokeWidth="0.5"
			/>
			<path
				d="M22.7452 22.0172L35.9759 22.0172L25.4615 35.5L12.2308 35.5L22.7452 22.0172Z"
				fill="none"
				stroke="currentColor"
			/>
			<path d="M20.759 25.093H33.834" stroke="currentColor" />
			<g clipPath="url(#clip0_11101_3394)">
				<path
					d="M10.7999 10.2544C10.3598 10.5047 9.99436 10.8354 9.71567 11.2638C9.6872 11.3076 9.60614 11.3368 9.54887 11.3381C9.24271 11.3452 8.93623 11.3425 8.62974 11.3408C8.5517 11.3405 8.49878 11.3483 8.47466 11.4467C8.24287 12.392 8.00472 13.336 7.76891 14.2803C7.76623 14.2905 7.77025 14.3024 7.77159 14.3238C7.9816 14.3238 8.19229 14.3268 8.40298 14.3231C8.87627 14.3153 9.35057 14.3197 9.82286 14.2909C10.4496 14.2525 10.9637 13.8251 11.0967 13.2058C11.1503 12.9561 11.0967 12.6834 11.098 12.4212C11.098 12.3367 11.0923 12.2377 11.1315 12.1705C11.3523 11.7913 11.6614 11.5393 12.116 11.507C12.2074 11.5006 12.2563 11.5209 12.2985 11.6054C13.0542 13.1199 12.2027 15.3037 10.3193 15.4794C10.0758 15.5022 9.8309 15.5222 9.58638 15.5232C8.46662 15.5279 7.34686 15.5252 6.22677 15.5252C6.16078 15.5252 6.09479 15.5252 6 15.5252C6.04924 15.3332 6.09245 15.1623 6.137 14.9917C6.56105 13.3747 6.98544 11.758 7.40749 10.1407C7.42959 10.0569 7.44936 9.99861 7.5552 9.99996C8.37384 10.0105 9.19314 10.003 10.0111 10.0308C10.2764 10.0396 10.539 10.1367 10.8026 10.193C10.8016 10.2133 10.8009 10.234 10.7999 10.2544Z"
					fill="currentColor"
				/>
				<path
					d="M19 10.0424C18.8857 10.4623 18.7812 10.8639 18.662 11.2608C18.6499 11.3012 18.5504 11.3368 18.4915 11.3368C17.773 11.3368 17.0549 11.3286 16.3364 11.3252C16.2366 11.3249 16.1357 11.3303 16.0373 11.3463C15.8467 11.3775 15.706 11.5111 15.6775 11.6753C15.6477 11.8466 15.7365 12.042 15.9029 12.1291C16.0155 12.1882 16.1391 12.2268 16.2603 12.2672C16.4978 12.3462 16.7387 12.4161 16.9758 12.4968C17.8768 12.8042 18.1475 13.5999 17.7985 14.4554C17.5623 15.0337 17.0807 15.3258 16.5032 15.4347C16.1237 15.5062 15.7301 15.5039 15.3422 15.5225C15.0924 15.5344 14.8411 15.5249 14.5906 15.5246C14.4141 15.5246 14.2978 15.4428 14.2385 15.2373C14.394 15.2373 14.5353 15.2386 14.6763 15.2373C14.9121 15.2342 15.0424 15.1189 15.0428 14.916C15.0431 14.7122 14.9148 14.5999 14.6773 14.5972C14.5494 14.5958 14.4211 14.5955 14.2931 14.5938C14.2828 14.5938 14.2724 14.5867 14.262 14.5829C14.2781 14.396 14.3866 14.2983 14.5956 14.2966C15.0022 14.2936 15.4089 14.2997 15.8152 14.2929C15.9354 14.2909 16.0597 14.2712 16.1743 14.2346C16.3337 14.1834 16.4335 14.0673 16.4526 13.8899C16.472 13.7119 16.4034 13.5694 16.252 13.4965C16.0272 13.3883 15.7907 13.3048 15.5583 13.2129C15.3258 13.1206 15.0796 13.0545 14.8616 12.9354C14.2925 12.6254 14.0691 12.0613 14.2104 11.3602C14.3645 10.5956 14.9945 10.0359 15.7639 10.0258C16.805 10.0119 17.8467 10.0264 18.8881 10.0292C18.9152 10.0292 18.9427 10.0356 19.0006 10.0427L19 10.0424Z"
					fill="currentColor"
				/>
				<path
					d="M15.1449 10.0319C15.0609 10.0801 15.0106 10.1102 14.959 10.1381C14.539 10.3636 14.2546 10.7035 14.1374 11.1716C14.1016 11.3141 14.0389 11.3527 13.8992 11.3507C13.3425 11.3422 12.7858 11.347 12.2291 11.3466C11.5284 11.3463 11.0407 11.8975 10.8977 12.371C10.8113 12.658 10.8133 12.9463 10.8809 13.2387C10.899 13.3167 10.8913 13.4202 10.8538 13.489C10.6408 13.8815 10.3018 14.0904 9.86837 14.1613C9.73004 14.1841 9.69654 14.0962 9.653 14.005C9.08055 12.7984 9.47312 11.3242 10.5714 10.5539C11.0799 10.1971 11.6443 10.0081 12.261 10.0048C13.1794 10 14.0982 10.0112 15.0167 10.0159C15.0468 10.0159 15.0769 10.0231 15.1446 10.0319H15.1449Z"
					fill="currentColor"
				/>
				<path
					d="M15.9987 19.9105H15.306C15.3007 19.8267 15.296 19.7511 15.2893 19.649C15.099 19.8474 14.888 19.9627 14.6361 19.9831C14.1179 20.0251 13.6935 19.7589 13.513 19.2623C13.3482 18.8088 13.3717 18.3634 13.6406 17.9519C13.9819 17.4299 14.6797 17.3275 15.16 17.7223C15.1761 17.7355 15.1938 17.7464 15.2354 17.7762V16.3356H15.9987V19.9105ZM14.1678 18.7212C14.1658 19.071 14.3903 19.326 14.7041 19.3311C15.0126 19.3359 15.2621 19.0743 15.2668 18.7413C15.2715 18.4027 15.0186 18.128 14.7054 18.1314C14.3949 18.1348 14.1699 18.3817 14.1678 18.7209V18.7212Z"
					fill="currentColor"
				/>
				<path
					d="M11.1847 19.9128H10.5004C10.494 19.8491 10.4883 19.7897 10.485 19.7538C10.3228 19.8233 10.1607 19.9169 9.98654 19.962C9.74001 20.0258 9.49717 19.9681 9.28246 19.8318C8.84769 19.556 8.86377 18.9173 9.30725 18.652C9.61139 18.4702 9.95271 18.4567 10.2907 18.4288C10.3399 18.4248 10.3898 18.4238 10.4374 18.4214C10.4625 18.2291 10.3888 18.1256 10.2006 18.0825C9.92658 18.0201 9.69948 18.129 9.47171 18.3027C9.34376 18.1636 9.21715 18.0259 9.08149 17.8787C9.3374 17.626 9.63919 17.514 9.9708 17.4784C10.1028 17.4642 10.2394 17.4662 10.3707 17.4838C10.8611 17.5503 11.1301 17.8027 11.1753 18.344C11.2185 18.8579 11.1847 19.3783 11.1847 19.9125V19.9128ZM10.4783 18.8688C10.2639 18.9047 10.0629 18.9281 9.86763 18.9753C9.7514 19.0035 9.68106 19.0994 9.69312 19.2287C9.70585 19.3637 9.80734 19.4139 9.9219 19.4349C10.2709 19.4994 10.4997 19.2877 10.4786 18.8688H10.4783Z"
					fill="currentColor"
				/>
				<path
					d="M16.7615 19.1995C16.9571 19.2795 17.1262 19.3569 17.3014 19.4162C17.359 19.4355 17.4424 19.4281 17.4947 19.3979C17.5543 19.3636 17.622 19.2948 17.6297 19.2334C17.636 19.1842 17.569 19.1028 17.5148 19.0736C17.423 19.0244 17.3158 19.0051 17.215 18.9736C17.1249 18.9454 17.0314 18.9254 16.9444 18.8894C16.7028 18.789 16.5287 18.6279 16.5039 18.3464C16.4774 18.0441 16.5866 17.806 16.8415 17.6418C17.2823 17.3583 18.0065 17.4326 18.4105 17.8114C18.2587 17.942 18.107 18.0723 17.9676 18.1924C17.8223 18.152 17.6421 18.0903 17.4568 18.0557C17.3567 18.037 17.2475 18.0781 17.2267 18.2019C17.2036 18.3379 17.3145 18.3671 17.4113 18.3969C17.5918 18.4525 17.7787 18.4909 17.9526 18.5631C18.1924 18.6625 18.3605 18.8358 18.382 19.1164C18.4054 19.423 18.3033 19.6696 18.0397 19.8361C17.5831 20.1245 16.7424 20.019 16.3689 19.6191C16.5089 19.4695 16.6493 19.3192 16.7615 19.1991V19.1995Z"
					fill="currentColor"
				/>
				<path
					d="M8.37827 18.3186C8.08418 18.0852 7.79913 18.0798 7.59682 18.2918C7.39417 18.5041 7.38278 18.9227 7.5737 19.149C7.76898 19.3806 8.0681 19.3908 8.40038 19.1666C8.53871 19.3372 8.67806 19.5095 8.81606 19.6802C8.40373 20.1259 7.45948 20.0981 6.99289 19.6364C6.52127 19.17 6.51859 18.3213 6.98719 17.8471C7.46216 17.3665 8.37191 17.3397 8.81807 17.8027C8.67437 17.9713 8.53 18.1409 8.3786 18.3186H8.37827Z"
					fill="currentColor"
				/>
				<path
					d="M12.5415 19.9091H11.7681V17.5601H12.5013C12.5093 17.6344 12.518 17.7144 12.5274 17.7982C12.6433 17.71 12.7441 17.6127 12.863 17.5503C12.9528 17.5031 13.0647 17.4946 13.1682 17.4807C13.2781 17.4662 13.3293 17.5109 13.3156 17.6368C13.2961 17.8142 13.2958 17.9936 13.2868 18.1792C13.2171 18.1792 13.1628 18.1798 13.1086 18.1792C12.7662 18.1747 12.5535 18.3742 12.5442 18.7259C12.5358 19.0468 12.5422 19.3684 12.5418 19.6896C12.5418 19.7571 12.5418 19.8243 12.5418 19.9091H12.5415Z"
					fill="currentColor"
				/>
				<path
					d="M11.2033 15.3797C11.6726 15.1399 11.9874 14.7973 12.2524 14.3991C12.2829 14.3536 12.3559 14.3136 12.4105 14.3119C12.6942 14.3034 12.9786 14.3044 13.2626 14.3099C13.4683 14.3139 13.5617 14.3926 13.6103 14.5975C13.4854 14.5975 13.3648 14.5945 13.2442 14.5982C13.0482 14.6043 12.9226 14.7267 12.9193 14.9096C12.9159 15.0907 13.0405 15.225 13.2318 15.2359C13.3577 15.243 13.484 15.2372 13.6264 15.2372C13.5795 15.4123 13.482 15.5167 13.3316 15.5178C12.6647 15.5215 11.9945 15.5758 11.3349 15.4194C11.3041 15.4123 11.2743 15.4014 11.2026 15.38L11.2033 15.3797Z"
					fill="currentColor"
				/>
			</g>
			<defs>
				<clipPath id="clip0_11101_3394">
					<rect width="13" height="10" fill="none" transform="translate(6 10)" />
				</clipPath>
			</defs>
		</svg>
	);
}

function VcPayIcon() {
	return (
		<>
			<svg
				width="37"
				height="37"
				viewBox="0 0 37 37"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				className="dark:inline-block hidden"
			>
				<path
					d="M0.906555 12.97H24.8226C25.6149 12.97 26.3748 13.3029 26.935 13.8953C27.4953 14.4878 27.81 15.2914 27.81 16.1293V32.8408C27.81 33.2557 27.7327 33.6665 27.5826 34.0498C27.4325 34.4331 27.2124 34.7813 26.935 35.0747C26.6576 35.3681 26.3283 35.6008 25.9658 35.7595C25.6034 35.9183 25.2149 36 24.8226 36H3.87697C3.08761 35.9953 2.33211 35.6603 1.77553 35.0684C1.21895 34.4764 0.906542 33.6756 0.906555 32.8408V12.97Z"
					stroke="white"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M3.21499 6.61572H21.5891C22.2014 6.61572 22.7885 6.87292 23.2214 7.33074C23.6543 7.78855 23.8976 8.40949 23.8976 9.05694V12.9701H0.906555V9.05694C0.906555 8.40949 1.14976 7.78855 1.58268 7.33074C2.0156 6.87292 2.60276 6.61572 3.21499 6.61572Z"
					stroke="white"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path d="M0.906555 9.79285H16.1915" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
				<path d="M18.5424 9.79285H20.3586" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
				<path
					d="M25.9429 4.5155C27.3611 3.52692 29.0224 3 30.721 3C32.4196 3 34.0809 3.52692 35.4991 4.5155"
					stroke="white"
					strokeMiterlimit="10"
					strokeLinecap="round"
				/>
				<path
					d="M26.9698 6.22082C28.0816 5.46656 29.3747 5.06561 30.6956 5.06561C32.0165 5.06561 33.3096 5.46656 34.4213 6.22082"
					stroke="white"
					strokeMiterlimit="10"
					strokeLinecap="round"
				/>
				<path
					d="M28.0306 7.96193C28.8715 7.42527 29.8412 7.15722 30.8228 7.19007C31.6583 7.20952 32.4768 7.44362 33.2076 7.87218"
					stroke="white"
					strokeMiterlimit="10"
					strokeLinecap="round"
				/>
				<path
					d="M30.6022 10.8429C31.0616 10.8429 31.4339 10.4491 31.4339 9.9633C31.4339 9.47753 31.0616 9.08374 30.6022 9.08374C30.1429 9.08374 29.7705 9.47753 29.7705 9.9633C29.7705 10.4491 30.1429 10.8429 30.6022 10.8429Z"
					fill="white"
				/>
				<g clipPath="url(#clip0_11043_292)">
					<path
						d="M10.677 31.9233C10.5855 31.9233 10.5042 31.8764 10.4584 31.7997L3.0356 19.3957C2.98984 19.319 2.98984 19.225 3.0356 19.1484C3.07881 19.0717 3.1627 19.0247 3.25168 19.0247L6.73176 19C6.82328 19 6.90462 19.047 6.95038 19.1236L10.672 25.3356L14.3249 19.1706C14.3707 19.094 14.4546 19.047 14.5461 19.047H18.1228C18.2143 19.047 18.2982 19.094 18.3439 19.1706C18.3897 19.2473 18.3897 19.3413 18.3439 19.4179L10.8982 31.7997C10.8524 31.8764 10.7686 31.9233 10.6796 31.9233H10.677ZM3.69399 19.5144L10.677 31.1839L17.6804 19.5416H14.6935L10.8982 25.9513C10.8524 26.028 10.766 26.0799 10.677 26.0749C10.5855 26.0749 10.5042 26.028 10.4584 25.9513L6.58941 19.4946L3.69654 19.5144H3.69399Z"
						fill="white"
					/>
					<path
						d="M10.6999 23.283C10.6084 23.283 10.5245 23.236 10.4788 23.1569L8.26463 19.3684C8.21888 19.2918 8.22142 19.1978 8.26463 19.1211C8.31039 19.0445 8.39428 18.9975 8.48325 18.9975H12.8887C12.9802 18.9975 13.0615 19.0445 13.1073 19.1211C13.153 19.1978 13.153 19.2918 13.1073 19.3684L10.916 23.1569C10.8703 23.2336 10.7864 23.283 10.6948 23.283H10.6999ZM8.92303 19.4945L10.6999 22.5337L12.4565 19.4945H8.92303Z"
						fill="white"
					/>
					<path
						d="M20.8479 23.4957C20.7411 23.4957 20.642 23.429 20.6064 23.3251C19.9861 21.4902 18.4863 21.7944 18.4227 21.8068C18.3236 21.829 18.2219 21.7894 18.1609 21.7103C18.0999 21.6312 18.0948 21.5248 18.1482 21.4383L19.4879 19.2374C19.5412 19.1484 19.6455 19.1014 19.7497 19.1187C21.6156 19.4377 22.668 20.3552 23.2247 21.0674C23.8297 21.8463 23.9873 22.5462 23.9949 22.5758C24.0229 22.7094 23.9365 22.8404 23.8017 22.8676L20.9063 23.4834C20.8885 23.4883 20.8707 23.4883 20.8529 23.4883L20.8479 23.4957ZM18.8269 21.2949C19.4446 21.3245 20.464 21.5966 21.0131 22.9591L23.4255 22.4472C23.2018 21.8191 22.3782 20.1425 19.8336 19.6405L18.8269 21.2949Z"
						fill="white"
					/>
					<path
						d="M17.9041 32C14.9477 32 13.2445 30.311 13.1708 30.2368C13.0945 30.1577 13.0768 30.039 13.1327 29.945L14.9833 26.7253C15.0367 26.6338 15.1435 26.5844 15.2477 26.6017C15.3544 26.619 15.4383 26.7006 15.4561 26.8045C15.4612 26.8267 15.8756 29.0622 17.4898 29.0622C17.505 29.0622 17.5203 29.0622 17.533 29.0622C19.2413 29.0202 20.1666 26.8712 20.1767 26.849C20.2047 26.7822 20.2606 26.7328 20.3293 26.708C20.3979 26.6858 20.4742 26.6907 20.5377 26.7278L23.0925 28.1472C23.2094 28.2115 23.2552 28.3574 23.1942 28.4737C23.123 28.6122 21.3868 31.8714 18.2066 31.9951C18.105 32 18.0033 32 17.9041 32ZM13.6741 30.0168C14.1343 30.4075 15.7434 31.592 18.1863 31.5005C20.6292 31.4065 22.1926 29.1537 22.6197 28.4539L20.525 27.2892C20.1971 27.9247 19.2133 29.5148 17.5457 29.5568C16.1933 29.5939 15.4409 28.444 15.1155 27.5068L13.6741 30.0192V30.0168Z"
						fill="white"
					/>
				</g>
				<rect x="24.5" y="22.5" width="5" height="5" rx="1.5" fill="black" stroke="white" />
				<path
					d="M27.75 25.5061C28.1642 25.5061 28.5 25.1689 28.5 24.753C28.5 24.3372 28.1642 24 27.75 24C27.3358 24 27 24.3372 27 24.753C27 25.1689 27.3358 25.5061 27.75 25.5061Z"
					fill="white"
				/>
				<defs>
					<clipPath id="clip0_11043_292">
						<rect width="21" height="13" fill="white" transform="translate(3 19)" />
					</clipPath>
				</defs>
			</svg>

			<svg
				width="37"
				height="37"
				viewBox="0 0 37 37"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				className="dark:hidden inline-block"
			>
				<path
					d="M0.906555 12.97H24.8226C25.6149 12.97 26.3748 13.3029 26.935 13.8953C27.4953 14.4878 27.81 15.2914 27.81 16.1293V32.8408C27.81 33.2557 27.7327 33.6665 27.5826 34.0498C27.4325 34.4331 27.2124 34.7813 26.935 35.0747C26.6576 35.3681 26.3283 35.6008 25.9658 35.7595C25.6034 35.9183 25.2149 36 24.8226 36H3.87697C3.08761 35.9953 2.33211 35.6603 1.77553 35.0684C1.21895 34.4764 0.906542 33.6756 0.906555 32.8408V12.97Z"
					stroke="black"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M3.21499 6.61572H21.5891C22.2014 6.61572 22.7885 6.87292 23.2214 7.33074C23.6543 7.78855 23.8976 8.40949 23.8976 9.05694V12.9701H0.906555V9.05694C0.906555 8.40949 1.14976 7.78855 1.58268 7.33074C2.0156 6.87292 2.60276 6.61572 3.21499 6.61572Z"
					stroke="black"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path d="M0.906555 9.79285H16.1915" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
				<path d="M18.5424 9.79285H20.3586" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
				<path
					d="M25.9429 4.5155C27.3611 3.52692 29.0224 3 30.721 3C32.4196 3 34.0809 3.52692 35.4991 4.5155"
					stroke="black"
					strokeMiterlimit="10"
					strokeLinecap="round"
				/>
				<path
					d="M26.9698 6.22082C28.0816 5.46656 29.3747 5.06561 30.6956 5.06561C32.0165 5.06561 33.3096 5.46656 34.4213 6.22082"
					stroke="black"
					strokeMiterlimit="10"
					strokeLinecap="round"
				/>
				<path
					d="M28.0306 7.96193C28.8715 7.42527 29.8412 7.15722 30.8228 7.19007C31.6583 7.20952 32.4768 7.44362 33.2076 7.87218"
					stroke="black"
					strokeMiterlimit="10"
					strokeLinecap="round"
				/>
				<path
					d="M30.6022 10.8429C31.0616 10.8429 31.4339 10.4491 31.4339 9.9633C31.4339 9.47753 31.0616 9.08374 30.6022 9.08374C30.1429 9.08374 29.7705 9.47753 29.7705 9.9633C29.7705 10.4491 30.1429 10.8429 30.6022 10.8429Z"
					fill="black"
				/>
				<g clipPath="url(#clip0_11043_310)">
					<path
						d="M10.677 31.9233C10.5855 31.9233 10.5042 31.8764 10.4584 31.7997L3.0356 19.3957C2.98984 19.319 2.98984 19.225 3.0356 19.1484C3.07881 19.0717 3.1627 19.0247 3.25168 19.0247L6.73176 19C6.82328 19 6.90462 19.047 6.95038 19.1236L10.672 25.3356L14.3249 19.1706C14.3707 19.094 14.4546 19.047 14.5461 19.047H18.1228C18.2143 19.047 18.2982 19.094 18.3439 19.1706C18.3897 19.2473 18.3897 19.3413 18.3439 19.4179L10.8982 31.7997C10.8524 31.8764 10.7686 31.9233 10.6796 31.9233H10.677ZM3.69399 19.5144L10.677 31.1839L17.6804 19.5416H14.6935L10.8982 25.9513C10.8524 26.028 10.766 26.0799 10.677 26.0749C10.5855 26.0749 10.5042 26.028 10.4584 25.9513L6.58941 19.4946L3.69654 19.5144H3.69399Z"
						fill="black"
					/>
					<path
						d="M10.6999 23.283C10.6084 23.283 10.5245 23.236 10.4788 23.1569L8.26463 19.3684C8.21888 19.2918 8.22142 19.1978 8.26463 19.1211C8.31039 19.0445 8.39428 18.9975 8.48325 18.9975H12.8887C12.9802 18.9975 13.0615 19.0445 13.1073 19.1211C13.153 19.1978 13.153 19.2918 13.1073 19.3684L10.916 23.1569C10.8703 23.2336 10.7864 23.283 10.6948 23.283H10.6999ZM8.92303 19.4945L10.6999 22.5337L12.4565 19.4945H8.92303Z"
						fill="black"
					/>
					<path
						d="M20.8479 23.4957C20.7411 23.4957 20.642 23.429 20.6064 23.3251C19.9861 21.4902 18.4863 21.7944 18.4227 21.8068C18.3236 21.829 18.2219 21.7894 18.1609 21.7103C18.0999 21.6312 18.0948 21.5248 18.1482 21.4383L19.4879 19.2374C19.5412 19.1484 19.6455 19.1014 19.7497 19.1187C21.6156 19.4377 22.668 20.3552 23.2247 21.0674C23.8297 21.8463 23.9873 22.5462 23.9949 22.5758C24.0229 22.7094 23.9365 22.8404 23.8017 22.8676L20.9063 23.4834C20.8885 23.4883 20.8707 23.4883 20.8529 23.4883L20.8479 23.4957ZM18.8269 21.2949C19.4446 21.3245 20.464 21.5966 21.0131 22.9591L23.4255 22.4472C23.2018 21.8191 22.3782 20.1425 19.8336 19.6405L18.8269 21.2949Z"
						fill="black"
					/>
					<path
						d="M17.9041 32C14.9477 32 13.2445 30.311 13.1708 30.2368C13.0945 30.1577 13.0768 30.039 13.1327 29.945L14.9833 26.7253C15.0367 26.6338 15.1435 26.5844 15.2477 26.6017C15.3544 26.619 15.4383 26.7006 15.4561 26.8045C15.4612 26.8267 15.8756 29.0622 17.4898 29.0622C17.505 29.0622 17.5203 29.0622 17.533 29.0622C19.2413 29.0202 20.1666 26.8712 20.1767 26.849C20.2047 26.7822 20.2606 26.7328 20.3293 26.708C20.3979 26.6858 20.4742 26.6907 20.5377 26.7278L23.0925 28.1472C23.2094 28.2115 23.2552 28.3574 23.1942 28.4737C23.123 28.6122 21.3868 31.8714 18.2066 31.9951C18.105 32 18.0033 32 17.9041 32ZM13.6741 30.0168C14.1343 30.4075 15.7434 31.592 18.1863 31.5005C20.6292 31.4065 22.1926 29.1537 22.6197 28.4539L20.525 27.2892C20.1971 27.9247 19.2133 29.5148 17.5457 29.5568C16.1933 29.5939 15.4409 28.444 15.1155 27.5068L13.6741 30.0192V30.0168Z"
						fill="black"
					/>
				</g>
				<rect x="24.5" y="22.5" width="5" height="5" rx="1.5" fill="white" stroke="black" />
				<path
					d="M27.75 25.5061C28.1642 25.5061 28.5 25.1689 28.5 24.753C28.5 24.3372 28.1642 24 27.75 24C27.3358 24 27 24.3372 27 24.753C27 25.1689 27.3358 25.5061 27.75 25.5061Z"
					fill="black"
				/>
				<defs>
					<clipPath id="clip0_11043_310">
						<rect width="21" height="13" fill="white" transform="translate(3 19)" />
					</clipPath>
				</defs>
			</svg>
		</>
	);
}
